import { render, staticRenderFns } from "./docRepoDownload.vue?vue&type=template&id=211aceb1&scoped=true"
import script from "./docRepoDownload.vue?vue&type=script&lang=js"
export * from "./docRepoDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211aceb1",
  null
  
)

export default component.exports